import React, { useState } from "react";
import FiltersModal from "./FiltersModal";
import companyData from "../../Data/CompanyData";
import categories from "../../Data/Categories";
import { ciudadesPeru } from "../../Data/PeruDistricts";
import filtrosTender from "../../Data/FiltrosTender";
import { Button } from "../../components/ui/button";
import {
  Sheet,
  SheetTrigger,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "../../components/ui/sheet";

const FiltroLicitaciones = ({ filters, setFilters, onClearFilters }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeFilter, setActiveFilter] = useState("");
  const [showFiltersMenu, setShowFiltersMenu] = useState(false);

  const optionsData = {
    categoria: [
      ...categories.filter((cat) => cat.label !== "Otro Servicio"),
      ...companyData.sectores,
    ].map((item) => ({ label: item.label, icon: item.icon })), // Asegurar formato correcto
    ciudad: ciudadesPeru.map((city) => ({ label: city, icon: "" })),
    condiciones_pago: filtrosTender.condicionesPago,
    duracion_contrato: filtrosTender.duracionContrato,
    fecha: filtrosTender.fechas,
  };

  const friendlyTitles = {
    categoria: "Categorías",
    ciudad: "Ciudades",
    condiciones_pago: "Condiciones de Pago",
    duracion_contrato: "Duración del Contrato",
    fecha: "Fechas",
  };

  const filterButtons = [
    { key: "categoria", label: "Categorías" },
    { key: "ciudad", label: "Origen servicio" },
    { key: "condiciones_pago", label: "Condiciones de pago" },
    { key: "duracion_contrato", label: "Duración de contrato" },
    { key: "fecha", label: "Fecha" },
  ];

  const isFilterActive = (key) =>
    Array.isArray(filters[key]) ? filters[key].length > 0 : Boolean(filters[key]?.length);

  const handleFilterClick = (filterType) => {
    setActiveFilter(filterType);
    setIsModalOpen(true);
  };

  const handleModalApply = (filterType, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [filterType]: value,
    }));
    setIsModalOpen(false);
  };

  const handleClearFilters = () => {
    onClearFilters();
  };

  return (
    <div className="mb-6 flex flex-wrap items-center gap-2">
      {/* Botones de escritorio */}
      <div className="hidden flex-wrap items-center gap-2 md:flex">
        {filterButtons.map((btn) => (
          <Button
            key={btn.key}
            variant={isFilterActive(btn.key) ? "default" : "outline"}
            onClick={() => handleFilterClick(btn.key)}
          >
            {btn.label}
          </Button>
        ))}
        <Button variant="ghost" onClick={handleClearFilters}>
          Limpiar Filtros
        </Button>
      </div>

      {/* Botón que abre el panel de filtros en mobile */}
      <Sheet open={showFiltersMenu} onOpenChange={setShowFiltersMenu}>
        <SheetTrigger asChild>
          <Button variant="outline" className="md:hidden">
            Mostrar filtros
          </Button>
        </SheetTrigger>
        <SheetContent side="left">
          <SheetHeader>
            <SheetTitle>Todos los filtros</SheetTitle>
          </SheetHeader>
          <div className="flex flex-col gap-2">
            {filterButtons.map((btn) => (
              <Button
                key={btn.key}
                variant={isFilterActive(btn.key) ? "default" : "outline"}
                className="w-full justify-start"
                onClick={() => handleFilterClick(btn.key)}
              >
                {btn.label}
              </Button>
            ))}
          </div>
          <div className="mt-4 flex flex-col gap-2 border-t border-border pt-4">
            <Button onClick={() => setShowFiltersMenu(false)}>Aplicar Filtros</Button>
            <Button variant="outline" onClick={handleClearFilters}>
              Limpiar Filtros
            </Button>
          </div>
        </SheetContent>
      </Sheet>

      {isModalOpen && (
        <FiltersModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          options={optionsData[activeFilter] || []}
          selectedOptions={filters[activeFilter] || []}
          setSelectedOptions={(newOptions) =>
            handleModalApply(activeFilter, newOptions)
          }
          title={`Seleccionar ${friendlyTitles[activeFilter] || activeFilter}`}
        />
      )}
    </div>
  );
};

export default FiltroLicitaciones;
